import React, { useState, useMemo, useEffect } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import moment from "moment";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import { Constants } from "../../CommonMethhods/Constants";
import Loader from "../../Components/Common/Loader";
import SmallLoader from "../../Components/Common/smallLoader";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function IncomeTrackingPage() {
  const storeToken = localStorage.getItem("ssoToken");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorResp, setErrorResp] = useState("");
  const [durationValue, setDurationValue] = useState("weekly");
  const [mainData, setMainData] = useState([]);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState();
  const [serverError, setServerError] = useState(false);
  const [error, setError] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: "SrNo",
    direction: "ascending",
  });

  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  //API start
  const getConsolidatedReportData = async (
    fileType,
    sizePage,
    durationValue,
    pageNo = 1
  ) => {
    if (fileType === "excel") {
      setSmallLoaderExcel(true);
    }
    if (page === 1 && fileType === "grid") {
      setLoader(true);
    }
    let payloadValue = {
      fileType: fileType,
      pageNo: pageNo,
      pageSize: sizePage,
      duration: durationValue,
      segment: "consolidated",
      fromDate: durationValue === "customRange" ? fromDate : "",
      toDate: durationValue === "customRange" ? toDate : "",
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.ConsolidatedReport_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        setError(false);
        setServerError(false);
        setCount(res?.data?.total);
        if (fileType === "grid") {
          if (page > 1) {
            setMainData((prev) => {
              return [...prev, ...res?.data?.consolidateList];
            });
          } else {
            setMainData(res?.data?.consolidateList);
          }
        } else {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setMainData([]);
        if (fileType !== "grid") {
          toast.error(res?.message);
        } else {
          setError(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setMainData([]);
      setServerError(error?.message);
      if (fileType === "excel") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setScrollLoader(false);
    }
  };
  //API end

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  useEffect(() => {
    // if (durationValue !== "customRange") {
    // setError("");
    getConsolidatedReportData("grid", 10, durationValue, page);
    // }
  }, [durationValue, page]);

  const handleFromDateChange = (e) => {
    setMainData([]);
    setError(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
    setServerError("");
    // setPage(1);
  };
  const handleToDateChange = (e) => {
    setMainData([]);
    setError(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
    setServerError("");
    // setPage(1);
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleOnClick = (e) => {
    if (fromDate.length > 0 && toDate.length > 0) {
      // if (e.target.value) {
        setMainData([])
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        if (e.target.value === "excel") {
          getConsolidatedReportData("excel", -1, durationValue, 1);
          setErrorResp("");
        } else if (e.target.value === "grid") {
          setErrorResp("");
          setLoader(true);
          getConsolidatedReportData("grid", 10, durationValue, 1);
        }
      } else {
        setErrorResp("Please Select Correct Date");
      }
      // }
    } else {
      setPage(1);
    }
  };

  const sortedData = useMemo(() => {
    let sortableItems = [...mainData];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [mainData, sortConfig]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const handleDropdownChange = (event) => {
    setPage(1);
    if (event.target.value) {
      setLoader(true);
      setDurationValue(event.target.value);
      setFromDate("");
      setToDate("");
      setError("");
      setServerError("");
      setMainData([]);
      setErrorResp("");
    }
  };

  const header = {
    SrNo: "Sr No",
    Alert_Source: "Alert Source",
    clientCode: "Client Code",
    clientName: "Client Name",
    transationValue: "Transactional Value",
    income: "Income",
    networth: "Networth",
    status: "Status",
  };

  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports income_report_wrapper">
        <div className="card-box">
          <div>
            <div className="income-header">
              <h2 className="report-title">
                Clients whose income are not commensurate with their transaction
                value
              </h2>
              <div className="right-side-header">
                <div className="d-flex Wrap-selection">
                  <button
                    value="excel"
                    className="income-download-btn"
                    onClick={handleOnClick}
                  >
                    {smallLoaderExcel ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-downloadIBA"></span>
                        Download
                      </>
                    )}
                  </button>
                  <div className="income_tracking_report_select">
                    <select onChange={handleDropdownChange}>
                      <option value="this-month">This Month</option>
                      <option value="today">Today</option>
                      <option value="weekly" selected>
                        {" "}
                        Weekly
                      </option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                      <option value="tilldate">Till Date</option>
                      <option value="customRange">Custom Range</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {durationValue === "customRange" ? (
              <div className="d-flex wrapdates">
                <>
                  <div className="col-md-4 col-sm-4 col-6">
                    <FromdateComponent
                      fromDate={handleFromDateChange}
                      formatDate={formatDate(fromDate)}
                      DateReverse={DateReverse}
                      clientWiseReportForCustomCalanderIcon={true}
                    />
                  </div>
                  <div className="col-md-4 col-sm-4 col-6">
                    <TodateComponent
                      toDate={handleToDateChange}
                      formatToDate={formatDate(toDate)}
                      DateReverse={DateReverse}
                      errorResponse={errorResp}
                      clientWiseReportForCustomCalanderIcon={true}
                    />
                  </div>
                </>
                <div className="text-center search-btn-wrapper">
                  {loader === true ? (
                    <button className="send-message" disabled>
                      {Constants.Submit}
                    </button>
                  ) : (
                    <button
                      value="grid"
                      className="send-message"
                      onClick={handleOnClick}
                    >
                      {Constants.Submit}
                    </button>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          <div
            className="scroll-table income_table for-grid-section"
            id="for-scroll-left"
            // onScroll={(e) => handleScroll(e)}
          >
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : mainData && mainData?.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    {Object.keys(header).map((key) => (
                      <th
                        scope="col"
                        key={key}
                        onClick={() => requestSort(key)}
                      >
                        <span className="invoice-th">
                          <span>{header[key]}</span>
                          <span
                            className={`arrow-column ${getClassNamesFor(key)}`}
                          >
                            <span className="icon-up-triangle"></span>
                            <span className="icon-down-triangle"></span>
                          </span>
                        </span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody onScroll={(e) => handleScroll(e)}>
                  {sortedData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.alertSource}</td>
                      <td>{item?.clientCode}</td>
                      <td>{item?.clientName}</td>
                      <td>{item?.transactionValue}</td>
                      <td>{item?.income}</td>
                      <td>{item?.networth}</td>
                      <td>
                        <p
                          className={`${
                            item?.status && item?.status.toLowerCase() === "yes"
                              ? "yesText"
                              : "noText"
                          }`}
                        >
                          {item?.status}
                        </p>
                      </td>
                    </tr>
                  ))}
                  {scrollLoader && (
                    <div className="loader-center">
                      <LoaderForSearch />
                    </div>
                  )}
                </tbody>
              </table>
            ) : (
              error &&
              !serverError && (
                <div className="report-error-message">{noDataFound(error)}</div>
              )
            )}
            {!loader && serverError && (
              <div className="report-error-message">
                {noDataFound(serverError)}
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default IncomeTrackingPage;
